"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7700],{

/***/ 72304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
}), 'Security'));

/***/ }),

/***/ 77316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
}), 'VerifiedUser'));

/***/ }),

/***/ 77700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ OurDifferencesSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/Chat.js


/* harmony default export */ var Chat = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
}), 'Chat'));
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Security.js
var Security = __webpack_require__(72304);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/VerifiedUser.js
var VerifiedUser = __webpack_require__(77316);
// EXTERNAL MODULE: ./styles/jss/bbhost/pages/landingPageSections/teamStyle.js
var teamStyle = __webpack_require__(57180);
// EXTERNAL MODULE: ./lang/lang.js + 3 modules
var lang = __webpack_require__(34426);
// EXTERNAL MODULE: ./configs/index.js + 16 modules
var configs = __webpack_require__(91856);
;// CONCATENATED MODULE: ./pages-sections/HomePage-Sections/OurDifferencesSection.js




// @material-ui/core components

// @material-ui/icons

// core components
var GridContainer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4041).then(__webpack_require__.bind(__webpack_require__, 64041));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64041)
            ];
        }
    }
});
var GridItem = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6680).then(__webpack_require__.bind(__webpack_require__, 96680));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96680)
            ];
        }
    }
});
var InfoArea = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6831).then(__webpack_require__.bind(__webpack_require__, 5323));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5323)
            ];
        }
    }
});

var useStyles = (0,makeStyles/* default */.Z)(teamStyle/* default */.Z);


function OurDifferencesSection(props) {
    var classes = useStyles();
    var locale = (0,router.useRouter)().locale;
    var differences = configs/* OUR_DIFFERENCES.map */.b1.map(function(contact, key) {
        var icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (typeof contact.text === "object") {
            contact.text = (0,lang/* getLangFromObj */.x)(contact.text, locale);
        }
        if (typeof contact.subText === "object") {
            contact.subText = (0,lang/* getLangFromObj */.x)(contact.subText, locale);
        }
        if (contact.icon === "chat") icon = Chat;
        if (contact.icon === "security") icon = Security/* default */.Z;
        if (contact.icon === "verifieduser") icon = VerifiedUser/* default */.Z;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
            xs: 12,
            sm: 12,
            md: 4,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                title: contact.text,
                description: contact.subText,
                icon: icon,
                iconColor: contact.iconColor,
                vertical: true
            })
        }, key);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.section,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridContainer, {
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridItem, {
                    xs: 12,
                    sm: 12,
                    md: 8,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: classes.title,
                            children: (0,lang/* trans */.d)("index::differential_section.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridContainer, {
                    children: differences
                })
            })
        ]
    });
}


/***/ })

}]);